<template>
  <div class="card">
    <span
      class="typography__body2 card__category"
      v-html="article.category.name"
    />

    <BaseLink
      class="card__name"
      :href="`/${locale}/faq/articles/${article.slug}`"
    >
      <span v-html="article.name" />
    </BaseLink>
  </div>
</template>

<script lang="ts" setup>
const { locale } = useI18n();

defineProps<{
  article: FaqArticleWithCategory;
}>();
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 8px;
  height: 100%;
  padding: 16px 24px;
  border-radius: 12px;
  background-color: var(--white);
}

.card__category {
  padding: 2px 8px;
  color: var(--grey-2);
  border-radius: 4px;
  background-color: var(--grey-7);
}

@media (--hover) {
  .card__name:hover {
    color: var(--grey-2);
  }
}

@media (--hover) {
  .card__name:active {
    color: var(--grey-1-5);
  }
}
</style>
